import { Link, useLocation } from 'react-router-dom';
import { buildCrumbs } from './breadcrumbTrail';
import { useProject } from '../project/context';
import styles from './Breadcrumbs.module.css';

/**
 * Breadcrumb trail rendered on every content page (Gate-fix #414). Gives a
 * persistent way back up the hierarchy — e.g. from a scan-discovery page back to
 * Scans and Home — on top of the header's primary navigation. The active project's
 * name is shown as a crumb when known (#434).
 */
export function Breadcrumbs() {
  const { pathname } = useLocation();
  const { currentProject } = useProject();
  const crumbs = buildCrumbs(pathname, currentProject?.name);
  if (crumbs.length === 0) return null;

  return (
    <nav aria-label="Breadcrumb" className={styles.breadcrumb}>
      <div className={styles.list}>
        {crumbs.map((crumb, index) => {
          const isLast = index === crumbs.length - 1;
          return (
            <span key={`${crumb.label}-${index}`} className={styles.item}>
              {crumb.to && !isLast ? (
                <Link to={crumb.to} className={styles.link}>
                  {crumb.label}
                </Link>
              ) : (
                <span className={styles.current} aria-current={isLast ? 'page' : undefined}>
                  {crumb.label}
                </span>
              )}
              {isLast ? null : (
                <span className={styles.separator} aria-hidden="true">
                  /
                </span>
              )}
            </span>
          );
        })}
      </div>
    </nav>
  );
}
